import {AnyAction, Dispatch} from "@reduxjs/toolkit";
import axios, {AxiosError} from "axios";
import {makerDataUrl, previewDataUrl} from "./url";
import {restorePreviewDataFromBackend, setStateFromBackend} from "../store/makerDataSlice";
import * as Sentry from "@sentry/react";

export default async function getPreviewData(previewId: string, dispatch: Dispatch<AnyAction>) {
    const getParams = {
        previewId: previewId,
    };

    const response = await axios.get(previewDataUrl, {params: getParams});
    if (response.data?.result == 'ok') {
        const previewData = response.data;
        dispatch(restorePreviewDataFromBackend(previewData));
    } else {
        throw ({
            message: 'Failed to load preview data. Wrong response.',
            response: response,
            responseConfig: JSON.stringify(response?.config),
            responseData: JSON.stringify(response?.data),
            url: previewDataUrl
        });
    }
}